export const google = Object.freeze({
    googleHref: "https://www.google.com/maps/dir//Szerencs+u.+172,+Budapest,+1154+Hungary/@47.5465313,19.0926905,13z/data=!4m9!4m8!1m0!1m5!1m1!1s0x4741db02a44e95f7:0xb4a85b50057bddec!2m2!1d19.1277114!2d47.5465526!3e3",
    googleKey: "AIzaSyCUeKMx2SkkEN4WjU93duca92Tjeo7Oi_w",
})

export const facebook = Object.freeze({
    miraLuxUrl: "https://www.facebook.com/Mira-Lux-kutyafodr%C3%A1szat-112210557574767",
});
